/**
 * Given an array of percent share objects, calculate the total percentage represented by the array
 * and return this within the result as .knownShares. Return the remaining percentage as the
 * .unknownShares.
 * @param percent_shares array of percent share objects
 */
export const calculatePercentSharesDetails = (
    percent_shares: ProEntityPercentShare[] | null,
    totalShares = 100,
): PercentSharesDetails => {
    if (percent_shares === null) {
        return {
            knownShares: 0,
            unknownShares: totalShares,
        };
    }

    const knownShares = percent_shares.reduce(
        (acc: number, { percent_share }: ProEntityPercentShare): number =>
            acc + percent_share,
        0,
    );

    const unknownShares = totalShares - knownShares;

    return {
        knownShares,
        unknownShares,
    };
};
